import React, { Component } from 'react'
import { message } from 'antd/lib/index'
import InvoicesApi from '../../../api/Sales/Invoices'
import Invoices from './Invoices'
import List from './List'
import Email from '../../../api/Email'
import Templates from '../../../api/Templates'
import { get, isEmpty, pick } from 'lodash'
import { dateFormat, dateVal, moneyInline, numVal, strVal } from '../../../modules/Utils'

class InvoicesCont extends Component {
  state = {
    list: [],
    emailDetails: {},
    selection: [],
    fetching: false,
    emailKey: '1',
  }
  tableRef = React.createRef()
  api = new InvoicesApi()
  emailApi = new Email()
  templateApi = new Templates()

  componentDidMount = async () => {
    await this.fetch()
  }

  fetch = async () => {
    try {
      this.setState({
        fetching: true,
      })
      const cached = await this.api.list(get(this.props, 'contract._id'), get(this.props, 'order._id'))
      let list = cached

      if (!isEmpty(this.state.company)) list = cached.filter((i) => i.company._id === this.state.company)

      this.setState({
        fetching: false,
        list,
        cached: list,
      })
    } catch (e) {
      message.error(e.errorMessage)
      this.setState({ fetching: false })
    }
  }
  showEmail = async () => {
    const selection = this.state.selection.map((t) => this.state.list.find((i) => i._id === t))
    if (!selection.reduce((prv, current) => (get(prv, 'client._id') === get(current, 'client._id') ? prv : NaN))) {
      message.error('Not the same Client')
      return
    }
    if (!selection.reduce((prv, current) => (get(prv, 'company._id') === get(current, 'company._id') ? prv : NaN))) {
      message.error('Not the same company')
      return
    }
    if (selection.find((s) => !['Confirmed', 'Paid'].includes(s.status))) {
      message.error(`Can't email non confirmed invoices`)
      return
    }
    try {
      this.setState({
        fetchingEmailTemplate: true,
      })
      const lines = selection.map((i) => ({
        date: dateFormat(dateVal(i, 'date')),
        no: i.revision ? strVal(i, 'code') + '.0' + strVal(i, 'revision') : strVal(i, 'code'),
        type: strVal(i, 'type'),
        amount: moneyInline(numVal(i, 'subTotal.net'), strVal(i, 'currency')),
        dueDate: dateFormat(dateVal(i, 'dueDate')),
      }))
      const invoiceTemplate = await this.templateApi.read(
        strVal(selection, '0.company._id').replace('members/', ''),
        'invoice'
      )
      const emailDetails = get(invoiceTemplate, 'email') || {}
      const data = await this.emailApi.invoiceTemplate({
        receiver: get(selection, '0.payableRep.fn'),
        companyRep: get(selection, '0.companyRep.fn'),
        lines: lines,
        ...emailDetails,
      })
      const filesList = await this.api.files(selection.map((s) => s._id))
      const filesMapped = filesList.map((f) => f.uuid)
      this.setState({
        visibleEmail: true,
        emailTemplate: data.html,
        fetchingEmailTemplate: false,
        emailFiles: filesList,
        emailLines: selection,
        emailDetails: {
          to: get(selection, '0.payableRep.email.label'),
          cc: get(selection, '0.companyRep.email.label'),
          bcc: get(emailDetails, 'bcc'),
          from: get(emailDetails, 'from'),
          subject: get(emailDetails, 'subject'),
          attachments: filesMapped,
        },
      })
    } catch (e) {
      console.error(e)
      message.error(e.errorMessage)
      this.setState({
        fetchingEmailTemplate: false,
      })
    }
  }
  onCancelEmail = () => {
    this.setState({
      visibleEmail: false,
      emailDetails: {},
      selection: [],
    })
  }
  filterCompany = (_id) => {
    this.setState((prevState, props) => ({
      company: _id,
      list: _id ? prevState.cached.filter((i) => i.company._id === _id) : prevState.cached,
    }))
  }
  toggleSelection = (key) => {
    let selection = [...this.state.selection]
    const keyIndex = selection.indexOf(key)
    if (keyIndex >= 0) {
      selection = [...selection.slice(0, keyIndex), ...selection.slice(keyIndex + 1)]
    } else {
      selection.push(key)
    }
    this.setState({ selection })
  }

  clearSelection = () => {
    this.setState({ selection: [] })
  }

  toggleAll = () => {
    const selectAll = !this.state.selectAll
    const selection = []
    if (selectAll) {
      const wrappedInstance = this.tableRef.current
      const currentRecords = wrappedInstance.getResolvedState().sortedData
      currentRecords.forEach((item) => {
        selection.push(item._original._id)
      })
    }
    this.setState({ selectAll, selection })
  }
  isSelected = (key) => {
    return this.state.selection.includes(key)
  }

  render() {
    let Cmp = Invoices
    if (this.props.type === 'list') Cmp = List
    return (
      <Cmp
        {...this.state}
        {...pick(this, [
          'fetch',
          'filterCompany',
          'showEmail',
          'onCancelEmail',
          'toggleSelection',
          'toggleAll',
          'isSelected',
          'tableRef',
          'clearSelection',
        ])}
      />
    )
  }
}

InvoicesCont.propTypes = {}
InvoicesCont.defaultProps = {}

export default InvoicesCont
